import LocationMenuButton from "./LocationMenuButton";
import { useState, useContext } from "react";
import { GameState } from "../GameState";

const TransferMenu = (props) => {
  const state = useContext(GameState);
  const { id } = props;
  const [ selected, setSelected ] = useState(false);

  return (
    <div className="transfermenu">
      <LocationMenuButton name="TRANSFER" action={() => setSelected(!selected)} />
      { selected && <LocationMenuButton name="25%" action={() => state.startTransfer(id, 0.25)} /> }
      { selected && <LocationMenuButton name="50%" action={() => state.startTransfer(id, 0.50)} /> }
      { selected && <LocationMenuButton name="100%" action={() => state.startTransfer(id, 1.00) }/> }
    </div>
  );
};

export default TransferMenu;
